import { useCallback } from "react";

import { twMerge } from "tailwind-merge";

import useNotification from "components/Notification/useNotification";
import useActivityTracker from "hooks/useActivityTracker";
import { fetchApi } from "utils/baseFetcher";

const RequestSubscriptionWidget = ({
  activityKey,
  toolUid,
}: {
  activityKey?: string;
  toolUid?: string;
}) => {
  const { setNotification } = useNotification();
  const { trackActivity } = useActivityTracker();
  const onClick = useCallback(() => {
    if (activityKey) {
      trackActivity(activityKey);
    } else if (toolUid) {
      fetchApi(`/api/v2/tools/${toolUid}/request-trial`, {
        method: "PATCH",
      });
    }
    setNotification(
      "Your request has been received. Our team will contact you with further details within 1-2 business days",
      "success"
    );
  }, []);

  return (
    <div
      className={twMerge(
        "bg-white align-middle px-[20px] py-[10px]",
        "rounded border border-solid border-light-gray"
      )}
    >
      <div className="flex items-center">
        <div>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="https://assets.smartkarma.com/icons/atom-utah.svg"
            alt="Data Subscriptions"
            width={58}
            height={58}
            className="pb-[2px]"
          />
        </div>
        <div className="ml-[10px]">
          <div className="text-[18px] font-medium">Data Subscriptions</div>
          <div className="text-[14px]">Learn more about the dataset.</div>
        </div>
      </div>
      <button
        className={twMerge(
          "border border-solid border-utah-sky rounded-full",
          "w-full py-[5px] h-[38px]",
          "text-utah-sky hover:text-white text-[13px] font-bold",
          "bg-white hover:bg-utah-sky",
          "mt-[15px]"
        )}
        onClick={onClick}
      >
        Request Information/Trial
      </button>
    </div>
  );
};

export default RequestSubscriptionWidget;
